import '../styles/components/footer.css'

export function renderFooter(outlet) {
  const year = new Date().getFullYear()
  outlet.innerHTML = `
    <footer class="site-footer">
      <div class="container">
        <div class="footer-top">
          <div class="footer-brand">
            <div class="footer-logo">Airplaten</div>
            <p class="footer-tagline">Carbon-infused tools engineered for professionals who won't settle.</p>
          </div>
          <div class="footer-links-group">
            <div class="footer-col">
              <div class="footer-col-title">Products</div>
              <ul class="footer-links">
                <li><a href="#/shop">All Products</a></li>
                <li><a href="/belt-grinder-platen">Belt Grinder Platens</a></li>
                <li><a href="/knife-sharpening-platen">Knife Sharpening Platens</a></li>
                <li><a href="/carbon-fiber-platen">Carbon Fiber Platens</a></li>
              </ul>
            </div>
            <div class="footer-col">
              <div class="footer-col-title">Resources</div>
              <ul class="footer-links">
                <li><a href="/knife-sharpening-belt-grinder">Sharpening Guide</a></li>
                <li><a href="/knife-making-tools">Knife Making Tools</a></li>
                <li><a href="/faq">FAQ</a></li>
              </ul>
            </div>
            <div class="footer-col">
              <div class="footer-col-title">Company</div>
              <ul class="footer-links">
                <li><a href="#/contact">Contact</a></li>
                <li><a href="/contact-us">Support</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div class="footer-bottom">
          <span>© ${year} Airplaten</span>
          <div style="display:flex; gap: var(--space-6);">
            <a href="/terms" style="color: var(--color-text-muted); font-size: var(--text-xs); text-decoration:none;">Terms</a>
            <a href="/privacy" style="color: var(--color-text-muted); font-size: var(--text-xs); text-decoration:none;">Privacy</a>
          </div>
        </div>
      </div>
    </footer>
  `
}
